import styled from 'styled-components';

import { mediaQuery } from '@savgroup-front-common/core/grid/helpers';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $LeftColumn = styled.div``;

export const $HeadingIcon = styled.span`
  margin-right: ${spacing('lg')};
  display: flex;
  align-items: baseline;
  & svg {
    width: ${spacing('xl')};
    height: ${spacing('xl')};
  }
`;

export const $DeliveryWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  ${mediaQuery.sm`
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: ${spacing('xxl')};
  `};
`;

export const $DeliveryItemWrapper = styled.div`
  flex: 1;
`;

export const $DeliveryResultWrapper = styled.div`
  flex: 1;
  margin-bottom: ${spacing('xxl')};
`;
